import type { PeriodWithMinutes } from './period-with-minutes';

/**
 * Compares a list of periods to a single period,
 * returns true if the single period does not overlap with any period in the list
 */
export function vacant(periods: PeriodWithMinutes[], period: PeriodWithMinutes) {
  let result = true;
  if (periods.length) {
    periods.forEach(function (item) {
      if (period.startMinutes < item.endMinutes && period.endMinutes > item.startMinutes) {
        result = false;
      }
    });
  }
  return result;
}
